// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"81cc2ae7","189":"27902499","250":"97c38708","331":"81cc2ae7","973":"a54f3c64"}[chunkId] + ".chunk.css";
};